import React, { useState } from "react";
import { Modal } from "react-bootstrap";

const YoutubeVideoPlayer = ({ isOpen, toggle, videoUrl }) => {
  const [loaded, setLoaded] = useState(false);
  const getEmbedUrl = (url) => {
    if (!url) return '';
    if (url.includes('/embed/')) return url;
    const videoId = url.split('v=')[1]?.split('&')[0]
      || url.split('youtu.be/')[1]?.split('?')[0];
    return videoId ? `https://www.youtube.com/embed/${videoId}` : url;
  };

  const embedUrl = getEmbedUrl(videoUrl);

  const frameLoad = () => {
    setLoaded(true);
  };

  return (
    <Modal
      show={isOpen}
      size="md"
      className="modal-dialog-centered dashboard-video-popup"
    >
      <div className="modal-header d-flex align-items-center justify-content-between p-3">
        <h5 className="modal-title FS16FW500">PTE Tutorial Videos</h5>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={toggle}
        ></button>
      </div>
      <Modal.Body className="d-flex align-items-center justify-content-center flex-column">
        <iframe
          className="dashboard-popup-video"
          src={embedUrl}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          onLoad={frameLoad}
          style={{
            width: "clamp(258px, 50vw, 444px)",
            height: "clamp(120px, 30vw, 250px)",
          }}
        ></iframe>
        {!loaded && (
          <div className="text-center">
            <p className="FS14FW600">Loading...</p>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default YoutubeVideoPlayer;
